var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { reduxForm } from 'redux-form';
import { goBack } from 'connected-react-router';
import FormHelperText from "@material-ui/core/FormHelperText";
import Grid from '@material-ui/core/Grid';
import i18next from 'i18next';
import { useAppDispatch } from '~store';
import { required } from '~utils/formValidators';
import { ER2003 } from '~utils/errorcodes';
import { useIsDesktop } from '~hooks';
import { Button, TextField } from '~atoms';
import { AlertDialogSlide } from '~molecules';
import { MODALS, closeModal, openModal } from '~modals';
import { usePasswordRestoreFormStyles } from './PasswordRestoreForm.styles';
var PasswordRestoreForm = function (_a) {
    var handleSubmit = _a.handleSubmit, onModalClose = _a.onModalClose;
    var t = useTranslation(['login', 'errors']).t;
    var isDesktop = useIsDesktop();
    var _b = useState(false), modalSuccessWindow = _b[0], setModalSuccessWindow = _b[1];
    var passwordRestoreFormClasses = usePasswordRestoreFormStyles();
    var dispatch = useAppDispatch();
    var _c = useState(false), banModal = _c[0], setBanModal = _c[1];
    var _d = useState(''), formError = _d[0], setFormError = _d[1];
    var _e = useState(false), isDataLoading = _e[0], setIsDataLoading = _e[1];
    var handleCloseBanModal = function () {
        setBanModal(false);
    };
    var goToThePreviousPage = function () {
        dispatch(goBack());
    };
    var successDesktopRestore = function () {
        dispatch(closeModal({ key: MODALS.RESTORE_PASSWORD }));
        dispatch(openModal({
            modalName: MODALS.SUCCESS_MODAL_NOTIFICATION,
            modalProps: {
                title: t('login:success'),
                subheader: t('login:new_password'),
            },
        }));
    };
    var openRestorePassword = function (data) {
        setIsDataLoading(true);
        fetch('auth-service/v1/users/password', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                lang: i18next.language,
            },
            body: JSON.stringify(data),
        })
            .then(function (res) { return __awaiter(void 0, void 0, void 0, function () {
            var errorBody, errorCode;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!res.ok) return [3 /*break*/, 1];
                        (isDesktop ? successDesktopRestore : setModalSuccessWindow)(true);
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, res.json()];
                    case 2:
                        errorBody = _d.sent();
                        errorCode = ((_b = (_a = errorBody === null || errorBody === void 0 ? void 0 : errorBody.errors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.exceptionCode) || ((_c = errorBody === null || errorBody === void 0 ? void 0 : errorBody[0]) === null || _c === void 0 ? void 0 : _c.code) || '';
                        setFormError(errorCode);
                        _d.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); })
            .catch(function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var res, errorCode, _a;
            var _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, ((_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.json())];
                    case 1:
                        res = _f.sent();
                        errorCode = ((_d = (_c = res === null || res === void 0 ? void 0 : res.errors) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.exceptionCode) || ((_e = res === null || res === void 0 ? void 0 : res[0]) === null || _e === void 0 ? void 0 : _e.code) || '';
                        if ((error === null || error === void 0 ? void 0 : error.status) === 401 && errorCode === ER2003) {
                            setBanModal(true);
                        }
                        else {
                            setFormError(errorCode);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _f.sent();
                        setFormError('ER0000');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); })
            .finally(function () {
            setIsDataLoading(false);
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: passwordRestoreFormClasses.root },
            React.createElement("h1", { className: passwordRestoreFormClasses.title }, t('login:header')),
            React.createElement("div", { className: passwordRestoreFormClasses.main },
                React.createElement("form", null,
                    React.createElement("div", { role: "button", tabIndex: 0, onClick: function () { return setFormError(''); } },
                        React.createElement(TextField, { name: "usernameOrEmail", title: t('login:email_or_username'), validators: required, titleClassName: passwordRestoreFormClasses.labelText, required: true })),
                    React.createElement(FormHelperText, { id: "component-error-text", error: !!formError, classes: { root: passwordRestoreFormClasses.formError } }, t("errors:".concat(formError))))),
            modalSuccessWindow ? (React.createElement(AlertDialogSlide, { open: true, handleClose: function () {
                    goToThePreviousPage();
                }, title: t('login:success'), content: t('login:new_password'), needConfirm: false })) : (React.createElement(React.Fragment, null)),
            React.createElement(Grid, { container: true, justify: "space-between" },
                React.createElement(Grid, null,
                    React.createElement(Button, { size: "large", variant: "outlined", color: "secondary", classes: { root: passwordRestoreFormClasses.button }, onClick: onModalClose || goToThePreviousPage }, t('login:cancel'))),
                React.createElement(Grid, null,
                    React.createElement(Button, { color: "primary", variant: "contained", classes: { root: passwordRestoreFormClasses.button }, disabled: isDataLoading || !!formError, onClick: handleSubmit(openRestorePassword) }, t('login:continue'))))),
        banModal ? (React.createElement(AlertDialogSlide, { handleClose: handleCloseBanModal, open: true, title: t('login:all_attemps'), content: t('login:locked_for_30_minutes'), needConfirm: false })) : null));
};
export default reduxForm({
    form: 'restore-form',
    touchOnChange: true,
})(PasswordRestoreForm);
